import React from "react";

/**
 * Tracks a container's inner height so a windowed list can be given one in
 * pixels — `react-window` cannot size itself from a flex parent.
 */
export const useElementHeight = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = React.useState(0);

  React.useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const measure = () => setHeight(node.clientHeight);
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, height] as const;
};
